const REQUEST_PERIOD = 'RequestPeriod';
const OVERLAP = 'Overlap';
const FULL_SHIFT = 'FullShift';

export const VtoPaycodeCreationType = Object.freeze({
    [REQUEST_PERIOD]: 0,
    [OVERLAP]: 1,
    [FULL_SHIFT]: 2,
});

const IndexedVtoPaycodeCreationType = Object.freeze({
    0: REQUEST_PERIOD,
    1: OVERLAP,
    2: FULL_SHIFT,
});

export const VtoPaycodeCreationTypeNames = Object.freeze({
    RequestPeriod: IndexedVtoPaycodeCreationType[VtoPaycodeCreationType.RequestPeriod],
    Overlap: IndexedVtoPaycodeCreationType[VtoPaycodeCreationType.Overlap],
    FullShift: IndexedVtoPaycodeCreationType[VtoPaycodeCreationType.FullShift],
});

